module.exports = __webpack_public_path__ + "static/img/super-chat-pass.d8a7ecf3.png";